import { render } from "./TraceTagDetail.vue?vue&type=template&id=b52ce4fc&scoped=true"
import script from "./TraceTagDetail.vue?vue&type=script&lang=js"
export * from "./TraceTagDetail.vue?vue&type=script&lang=js"

import "./TraceTagDetail.vue?vue&type=style&index=0&id=b52ce4fc&lang=less&scoped=true"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52ce4fc"]])

export default __exports__